/*
 * ─── TONIGHT EVENT CONFIG ───
 * Single source of truth for the current event.
 * Change ONLY here — all components read from this.
 */
export const TONIGHT_EVENT = {
  title: "Bulbbul, six years on",
  film: "Bulbbul",
  eyebrow: "A watch party",
  description: "Watch Bulbbul on Netflix. We meet in the room on this site at 9 PM IST sharp. The film is more frightening, more tender, more itself, six years later.",
  scheduled_at: "2026-06-24T21:00:00+05:30",
  event_end: "2026-06-24T23:00:00+05:30",
  urgency: "Everyone is welcome. The room is small on purpose.",
  joinRoomUrl: "/watch-party/bulbbul-six-years",
  postRsvp: {
    heading: "You're in.",
    subhead: "We'll remind you before it starts. See you Wednesday 9 PM IST.",
  },
  bmsLink: "",
  whatsapp: "https://chat.whatsapp.com/DmChZFC7pPS0HiOh4QG03b",
};
